import {ActionContext, ActionTree} from 'vuex';
import {RootState} from '@/store/type';
import {HttpService} from '@/services/api';
import {Branch, BranchInitState, FilterBranch, ResponseBranch} from '@/store/branch/branch.types';
import {BranchEnumApi} from '@/store/branch/branch.enum';

export const BranchAction: ActionTree<BranchInitState, RootState> = {
  async _getBranch(req: ActionContext<BranchInitState, RootState>, params?: Branch): Promise<void> {
    let {commit} = req;
    try {
      let branchs = await HttpService.get(`${BranchEnumApi.branch}member`, params) as { data: ResponseBranch };
      if (branchs.data.appCode === 20000) {
        commit('mutationGetBranch', branchs.data.data);
      } else {
        commit('mutationGetBranch', []);
      }
    } catch (e) {
      commit('mutationGetBranch', []);
      console.error('DEBUG: _getBranch ', e.message);
    }
  },
  async _insertBranch(req: ActionContext<BranchInitState, RootState>, payload: Branch): Promise<void> {
    try {
      let {dispatch} = req;
      let res = await HttpService.post(BranchEnumApi.branch, payload);
      await dispatch('_getBranch');
      return res;
    } catch (e) {
      console.error('DEBUG: _insertBranch ', e.message);
    }
  },
  async _updateBranch(req: ActionContext<BranchInitState, RootState>, payload: Branch): Promise<void> {
    try {
      let {dispatch} = req;
      let res = await HttpService.put(BranchEnumApi.branch, payload);
      await dispatch('_getBranch');
      return res;
    } catch (e) {
      console.error('DEBUG: _updateBranch ', e.message);
    }
  },
  async _deleteBranch(req: ActionContext<BranchInitState, RootState>, payload: string): Promise<void> {
    try {
      let {dispatch} = req;
      let res = await HttpService.delete(BranchEnumApi.branch, payload);
      await dispatch('_getBranch');
      return res;
    } catch (e) {
      console.error('DEBUG: _deleteBranch ', e.message);
    }
  },
  async _getByBranchNo(req: ActionContext<BranchInitState, RootState>, payload: string): Promise<void> {
    try {
      let res = await HttpService.get(`${BranchEnumApi.branch}branchNo/${payload}`);
      return res.data.total;
    } catch (e) {
      console.error('DEBUG: _deleteBranch ', e.message);
    }
  },
  async _getBranchForRegister(req: ActionContext<BranchInitState, RootState>, params?: Branch): Promise<void> {
    let {commit} = req;
    try {
      let branchs = await HttpService.get(`${BranchEnumApi.branch}register`, params) as { data: ResponseBranch };
      if (branchs.data.appCode === 20000) {
        commit('mutationGetBranch', branchs.data.data);
      } else {
        commit('mutationGetBranch', []);
      }
    } catch (e) {
      commit('mutationGetBranch', []);
      console.error('DEBUG: _getBranch ', e.message);
    }
  },
  async _getByBranchId(req: ActionContext<BranchInitState, RootState>, payload: string): Promise<void> {
    try {
      let res = await HttpService.get(`${BranchEnumApi.branch}member/${payload}`);
      return res.data.data[0];
    } catch (e) {
      console.error('DEBUG: _getByBranchId ', e.message);
    }
  },
  async _getBranchForMember(req: ActionContext<BranchInitState, RootState>, params?: FilterBranch): Promise<void> {
    try {
      let res = await HttpService.get(`${BranchEnumApi.branch}member`, params);
      return res.data.data;
    } catch (e) {
      console.error('DEBUG: _getByBranchId ', e.message);
    }
  },
};
